module.exports = __webpack_public_path__ + "static/media/d1p.73b79e74.jpg";